import { createTranslator } from "../PlayerCore/i18n.js"

// SC-1323: the Portal Player page's own strings, in every core locale. German is formal ("Sie"),
// Spanish es-ES informal ("tú"), Portuguese pt-PT.
export const PORTAL_MESSAGES = {
    en: {
        "Lesson unavailable": "Lesson unavailable",
        "This lesson can't be played right now. Please try again later.": "This lesson can't be played right now. Please try again later.",
    },
    nl: {
        "Lesson unavailable": "Les niet beschikbaar",
        "This lesson can't be played right now. Please try again later.": "Deze les kan nu niet worden afgespeeld. Probeer het later opnieuw.",
    },
    de: {
        "Lesson unavailable": "Lektion nicht verfügbar",
        "This lesson can't be played right now. Please try again later.": "Diese Lektion kann gerade nicht abgespielt werden. Bitte versuchen Sie es später erneut.",
    },
    es: {
        "Lesson unavailable": "Lección no disponible",
        "This lesson can't be played right now. Please try again later.": "Esta lección no se puede reproducir ahora. Inténtalo de nuevo más tarde.",
    },
    da: {
        "Lesson unavailable": "Lektion utilgængelig",
        "This lesson can't be played right now. Please try again later.": "Denne lektion kan ikke afspilles lige nu. Prøv igen senere.",
    },
    fr: {
        "Lesson unavailable": "Leçon indisponible",
        "This lesson can't be played right now. Please try again later.": "Cette leçon ne peut pas être lue pour le moment. Veuillez réessayer plus tard.",
    },
    it: {
        "Lesson unavailable": "Lezione non disponibile",
        "This lesson can't be played right now. Please try again later.": "Questa lezione non può essere riprodotta ora. Riprova più tardi.",
    },
    pl: {
        "Lesson unavailable": "Lekcja niedostępna",
        "This lesson can't be played right now. Please try again later.": "Tej lekcji nie można teraz odtworzyć. Spróbuj ponownie później.",
    },
    pt: {
        "Lesson unavailable": "Lição indisponível",
        "This lesson can't be played right now. Please try again later.": "Esta lição não pode ser reproduzida agora. Tente novamente mais tarde.",
    },
    sv: {
        "Lesson unavailable": "Lektionen är inte tillgänglig",
        "This lesson can't be played right now. Please try again later.": "Den här lektionen kan inte spelas upp just nu. Försök igen senare.",
    },
}

export function createPortalTranslator(locale) {
    return createTranslator(locale, { messages: PORTAL_MESSAGES })
}
